import React, { useEffect, useState } from "react";
import {
    Modal,
    ModalHeader,
    ModalBody,
    ModalFooter,
    Button,
    Accordion,
    AccordionItem,
    AccordionHeader,
    AccordionBody,
    Input
} from "reactstrap";
import axios from "axios";
import { use } from "react";
import { i } from "framer-motion/client";


const SelectContentsModal = ({ isOpen, toggle, headsetId, onSaved, initialContents }) => {
    const [data, setData] = useState([]);
    const [openUser, setOpenUser] = useState();
    const [openProject, setOpenProject] = useState();
    const [selected, setSelected] = useState([]);

    const toggleUser = (id) => setOpenUser(prev => prev === id ? undefined : id);
    const toggleProject = (id) => setOpenProject(prev => prev === id ? undefined : id);

    useEffect(() => {
        if (isOpen) {
            axios.get("/api/content/listContenue")
                .then(res => setData(res))
                .catch(console.error);
        }
    }, [isOpen]);

    useEffect(() => {
        if (isOpen) {
        setSelected(initialContents ? initialContents.split("|") : []);
        }
    }, [isOpen, initialContents]);

    const toggleSelection = (value) => {
        setSelected(prev =>
            prev.includes(value)
                ? prev.filter(v => v !== value)
                : [...prev, value]
        );
    };

    const handleSave = async () => {
        await axios.post("/api/headset/assign-contents", {
            headset_id: headsetId,
            contents: selected
        });
        onSaved();
        toggle();
    };

    return (
        <Modal isOpen={isOpen} toggle={toggle} size="lg">
            <ModalHeader toggle={toggle}>Attribuer des contenus</ModalHeader>

            <ModalBody>
                <Accordion open={openUser} toggle={toggleUser}>
                    {data.map((user, uIndex) => {
                        // Vérifie si au moins une langue de cet utilisateur est cochée
                        const userHasChecked = user.projects.some(project =>
                            project.languages.some(lang =>
                                selected.includes(`${user.user}/${project.name}/${lang}`)
                            )
                        );
                        return (
                            <AccordionItem key={uIndex}>
                                <AccordionHeader targetId={`user-${uIndex}`}>
                                    <i className="mdi mdi-account-outline - fs-4 text-primary"></i> {userHasChecked ? <strong>{user.user}</strong> : user.user}
                                </AccordionHeader>

                                <AccordionBody accordionId={`user-${uIndex}`}>
                                    <Accordion open={openProject} toggle={toggleProject}>
                                        {user.projects.map((project, pIndex) => {
                                            // Vérifie si au moins une langue de ce projet est cochée
                                            const projectHasChecked = project.languages.some(lang =>
                                                selected.includes(`${user.user}/${project.name}/${lang}`)
                                            );
                                            return (
                                                <AccordionItem key={pIndex}>
                                                    <AccordionHeader targetId={`project-${uIndex}-${pIndex}`}>
                                                        <i className="mdi mdi-folder-multiple-outline - fs-4 text-secondary me-2"></i>{projectHasChecked ? <strong>{project.name}</strong> : project.name}
                                                    </AccordionHeader>

                                                    <AccordionBody accordionId={`project-${uIndex}-${pIndex}`}>
                                                        {project.languages.map(lang => {
                                                            const value = `${user.user}/${project.name}/${lang}`;
                                                            return (
                                                                <div key={lang} className="form-check mb-2">
                                                                    <Input
                                                                        type="checkbox"
                                                                        className=""
                                                                        checked={selected.includes(value)}
                                                                        onChange={() => toggleSelection(value)}
                                                                    />
                                                                    <label className="form-check-label ms-2">
                                                                        📁 {lang}
                                                                    </label>
                                                                </div>
                                                            );
                                                        })}
                                                    </AccordionBody>
                                                </AccordionItem>
                                            );
                                        })}
                                    </Accordion>
                                </AccordionBody>
                            </AccordionItem>
                        );
                    })}
                </Accordion>
            </ModalBody>

            <ModalFooter>
                <Button color="secondary" onClick={toggle}>Annuler</Button>
                <Button color="primary" onClick={handleSave}>
                    Valider ({selected.length})
                </Button>
            </ModalFooter>
        </Modal>
    );
};

export default SelectContentsModal;


//Creators : Florian Cohen-Joly / Franck Douaud @3DDGAMES -- Under license